import React , {useState, useRef}from 'react';
import {Table, TableBody,  TableHead, TableRow,TableCell, Typography, Paper} from '@mui/material';
import { TransactionDetails } from '../types/StockhornTypes';
import {Cookies}  from '../js/localStorageCode';

interface finalData {
  rows: TransactionDetails[];
  amount: string;
  [key: string]: any; // For any additional metadata
}
interface TableForEditingProps {
    data: finalData;
    length: number;
    onClose?: () => void;
    edit?: boolean;
}


export const TableForEditing: React.FC<TableForEditingProps> = ({ data, length, onClose, edit=true}) => {
    const cookies = new Cookies();
    const rows = data.rows;
    const allFields = Object.keys(rows[0] || {});
    const displayedTransactions:TransactionDetails[] = rows;
    const addOrRemoveRef = useRef<'Add'|'Remove'|null>(null); 

    const [selectedRowsIndex, setSelectedRowsIndex] = useState<number[]>([]);
    //const [selectedAddedRowsIndex, setSelectedAddedRowsIndex] = useState<number[]>([]);
    const toggleRowSelection = (e: React.MouseEvent<HTMLTableCellElement, MouseEvent>) => {
        const index = Number((e.target as HTMLElement).getAttribute('data-index'));
        selectedRowsIndex.includes(index) ? setSelectedRowsIndex(prev => prev.filter(i => i !== index)) : setSelectedRowsIndex(prev => [...prev, index]);
    }

    const HeaderRowEntries = ({key, field}: {key: keyof TransactionDetails; field: keyof TransactionDetails}) => {
        return (
            <TableCell key={key}>{field}</TableCell>
        );
    }

    const TableRowEntries = ({field, text, index}: {field: keyof TransactionDetails; text: string|undefined, index:number}) => {
        if(edit){
        return (
                <TableCell key={field} data-index={index}
                onClick={(e) => toggleRowSelection(e)}
                style={{cursor: 'pointer'}}
                >{text}
                </TableCell>
            );
        } else {
            return (
                <TableCell key={field}>{text}</TableCell>
            );
        }
    }

    const removeEntries = () => {
        addOrRemoveRef.current = 'Remove';
        if (selectedRowsIndex.length === 0) return;
        const newRows = rows.filter((_, index) => !selectedRowsIndex.includes(index));
        data.rows = newRows;
        setSelectedRowsIndex([]);
    }

    const addEntries = () => {
        addOrRemoveRef.current = 'Add';
        if (selectedRowsIndex.length === 0) return;
        const newRows = rows.filter((_, index) => selectedRowsIndex.includes(index));
        data.rows = newRows;
        setSelectedRowsIndex([]);
    }

    const storeFilteredTransactions = () => {
        const name = 'EDITED_'+ new Date().toISOString().split('.')[0]+'_Filter_on_"'+data.filterUsed+'='+data.columnFiltered+'"_from-';
        cookies.setWithReducer(name, data.rows, {columnFiltered:data.columnFiltered, filterUsed:data.filterUsed}, {expires: 365});
        onClose && onClose();
    }

    return (
        <Paper elevation={0} sx={{ mb: 4, p: 0 }}>
            <Typography variant="h6" textAlign={'center'}>Original Transactions from <span className={'fileNames'}>{'blah'}</span>, we have {rows.length} entries</Typography>
            {selectedRowsIndex.length > 0 && <div><button onClick={removeEntries}>Remove Highlighted entries</button>&nbsp;&nbsp;&nbsp;&nbsp;<button onClick={addEntries}>ADD Highlighted entries</button></div>}
            {addOrRemoveRef.current !== null && <button onClick={storeFilteredTransactions}>Save Entries</button>}
            <Table stickyHeader>
                <TableHead>
                    <TableRow>
                    {allFields.map(field => (
                        <HeaderRowEntries field={field as keyof TransactionDetails} key={field as keyof TransactionDetails}  />
                    ))}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {displayedTransactions.map((transaction, index) => (
                    <TableRow key={index} style={(selectedRowsIndex.includes(index)) ? {background: "#ddd"}:{background: 'inherit'}}>
                        {allFields.map(field=>
                        <TableRowEntries text={transaction[field as keyof TransactionDetails]} field={field as keyof TransactionDetails} key={field} index={index}/>
                        )}
                    </TableRow>
                    ))}
                </TableBody>
            </Table>
             {selectedRowsIndex.length > 0 && <div><button onClick={removeEntries}>Remove Highlighted entries</button>&nbsp;&nbsp;&nbsp;&nbsp;<button onClick={addEntries}>ADD Highlighted entries</button></div>}
        </Paper>
    );
}